import React from "react";
import Modal from "../../../BrandSignup/Modal"

import {useMutation} from "@apollo/client";
import {Controller, useForm} from "react-hook-form";
import {UPDATE_USER_INFO} from "../../WithUserData/queries";
import {ContactInfoCityInput} from "../../../TalentApplication/StepDetails_1st/cities-auto-complete";


const UpdateFieldModal = ({ fieldToUpdate, setFieldToUpdate, defaultValues, onSuccess }) => {

    const [updateUserInfo] = useMutation(UPDATE_USER_INFO)

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        getValues,
        setError,
        clearErrors,
        reset,
    } = useForm({
        defaultValues
    })

    const saveNewValue = async () => {
        let newValue = getValues("newValue");
        if(fieldToUpdate.key === "homeCity"){
            if(getValues("homeCity").geonamesId === defaultValues.homeCity.geonamesId){
                closeModal();
                return;
            }
            newValue = {geonamesId: getValues("homeCity").geonamesId};
        } else if (newValue === defaultValues[fieldToUpdate.key]) {
            closeModal();
            return;
        }

        try {
            const userDetails = {
                _id: defaultValues['_id'],
            }
            userDetails[fieldToUpdate.key] = newValue
            await updateUserInfo({
                variables: {
                    input: userDetails,
                },
            })
            onSuccess();
        } catch (err) {
            setError("newValue", {
                type: "manual",
                message: err.message,
            });
        }
    }

    const closeModal = () => {
        reset()
        clearErrors();
        setFieldToUpdate({});
    }

    return (
        <Modal isOpenModal={!!fieldToUpdate.key} closeModal={closeModal} light={true}>
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    handleSubmit(() => saveNewValue())();
                }}
                className="space-y-4 w-full max-w-sm px-4 pb-6"
            >
                {fieldToUpdate.key === "homeCity" && <Controller
                    name="homeCity"
                    control={control}
                    rules={{
                        validate: (val) => val?.name?.trim() ? true : "Home city is required"
                    }}
                    render={({field, fieldState}) => (
                        <ContactInfoCityInput
                            value={field.value}
                            onChange={field.onChange}
                            error={fieldState.error?.message}
                        />
                    )}
                />}
                {fieldToUpdate.key !== "homeCity" && <div className="mb-3">
                    <label className="block mb-4 text-black">{fieldToUpdate.label}:</label>
                    <div className="flex w-full">
                        <input
                            defaultValue={defaultValues[fieldToUpdate.key]}
                            {...register("newValue", fieldToUpdate.options)}
                            className="w-full border outline-none p-2 rounded bg-gray-300 hover:bg-gray-400 text-black"
                            style={{
                                borderColor: errors.newValue ? "#e53935" : "#404040"
                            }}
                        />
                    </div>
                    {errors.newValue && <p className="text-red-500 text-sm">{errors.newValue.message}</p>}
                </div>}

                <div className="flex justify-content-end mt-16">
                    <button
                        type="button"
                        className="cursor-pointer w-24 py-1 bg-gray-300 text-black rounded-xl flex items-center justify-center mx-auto hover:bg-gray-400"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className={`w-24 py-1 bg-gray-300 text-black rounded-xl flex items-center justify-center mx-auto cursor-pointer hover:bg-gray-400`}
                    >
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    )
}

export default UpdateFieldModal;